export enum SAPSCategory {
    XL = 'XL',
    L = 'L',
    M = 'M',
    S = 'S',
    XS = 'XS'
}